
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class PayrollPeriodGrid extends Serenity.EntityGrid<PayrollPeriodRow, any> {
        protected getColumnsKey() { return 'HR.PayrollPeriod'; }
        protected getDialogType() { return PayrollPeriodDialog; }
        protected getIdProperty() { return PayrollPeriodRow.idProperty; }
        protected getInsertPermission() { return PayrollPeriodRow.insertPermission; }
        protected getLocalTextPrefix() { return PayrollPeriodRow.localTextPrefix; }
        protected getService() { return PayrollPeriodService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}